import { Link } from 'react-router';
import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function Navbar() {
    const navElement = useRef(null);
    const [needsWhiteText, setWhiteText] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const routeColour = {
        '/': 'white-bg',
        '/services': 'orange-bg-3',
        '/how-we-work': 'blue-bg-2',
        '/contact': 'white-bg',
        '/terms-of-service': 'white-bg',
        '/privacy-policy': 'white-bg'
    };

    const location = useLocation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    useEffect(() => {
        if (!navElement.current) return;
        setWhiteText(!navElement.current.classList.contains('white-bg'));
    }, [location]);

    return (
        <nav ref={navElement} className={`navbar navbar-expand-md navbar-padding nav-colour fixed-top ${routeColour[location.pathname]}`}>
            <div className="container-fluid">
                <a href="/">
                    <img src="images/MMM-Logo.png" alt='MapleMark Media Logo' style={{ width: "50px", height: "auto" }} />
                </a>
                <button
                    className={`navbar-toggler ${needsWhiteText ? 'navbar-toggler-white' : 'navbar-toggler-dark'}`}
                    type="button"
                    onClick={() => setMenuOpen(prev => !prev)}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
                    <div className="navbar-nav ms-auto align-items-md-center">
                        <Link className={`hind-mysuru-semibold nav-button ${needsWhiteText ? "white-text" : ""}`} to="/services">Our Services</Link>
                        <Link className={`hind-mysuru-semibold nav-button ${needsWhiteText ? "white-text" : ""}`} to="/how-we-work">How We Work</Link>
                        <a className="contact-button-nav" href='/contact'>Get Started</a>
                    </div>
                </div>
            </div>
        </nav>
    );
}
export default Navbar;
